import React from 'react'; 
import Auxiliary from '../../HOC/Auxiliary/Auxiliary';
import Banner from '../../Components/Banner/Banner';
import CompanyInfo from './Sections/CompanyInfo';
import OurServices from './Sections/OurServices';
import Statements from './Sections/Statements';
const aboutus = ()=>{
     return(
         <Auxiliary>
            <Banner brand="aboutus">
                 <h1 className="bg-text1 mb-1">About <span className="text-color2">Us</span></h1> 
            </Banner>
            <CompanyInfo />
            <OurServices />
            <Statements  />
         </Auxiliary>
     )
 }

 export default aboutus;